import Felhasznalo from "./pages/admin/Felhasznalo/Felhasznalo";
import AdminMainPage from "./pages/admin/MainPage/AdminMainPage";
import Auth from "./pages/auth/Auth";
import { Routes, Route } from "react-router-dom";
import { ROUTES } from "./constants/Routes";
import FelhasznaloModsitasa from "./pages/admin/Felhasznalo/FelhasznaloModsitasa";
import KalkulacioList from "./pages/calculator/List/KalkulaciokLIst/KalkulacioList";
import KalkulacioAdatlapja from "./pages/calculator/Form/KalkulacioAdatlapja/KalkulacioAdatlapja";
import UjUgyfelAdatok from "./pages/calculator/Form/KalkulacioTuratervezes/UjUgyfelAdatok/UjUgyfelAdatok";
import Turatervezes from "./pages/calculator/Form/KalkulacioTuratervezes/Turatervezes/Turatervezes";
import KalkulacioAdatok from "./pages/calculator/Form/KalkulacioAdatok/KalkulacioAdatok";
import KalkulacioTetellista from "./pages/calculator/Form/KalkulacioTetellista/KalkulacioTetellista";
import KalkulacioLogisztikai from "./pages/calculator/Form/KalkulacioLogisztikai/KalkulacioLogisztikai";
import KalkulacioOsszegzes from "./pages/calculator/Form/KalkulacioOsszegzes/KalkulacioOsszegzes";
import Zonak from "./pages/admin/Zonak/Zonak";
import WohnZimmer from "./pages/admin/ZoneItems/WohnZimmer";
import Dijak from "./pages/admin/Dijak/Dijak";
import Ugyfelek from "./pages/admin/Ugyfelek/Ugyfelek";
import RequireAuth from "./components/Auth/RequireAuth";
import IsAuth from "./components/Auth/IsAuth";
import "react-toastify/dist/ReactToastify.css";
import ZonakAdd from "./pages/admin/Zonak/ZonakAdd";
import ZonakEdit from "./pages/admin/Zonak/ZonakEdit";
import ItemProfileCreate from "./pages/admin/ZoneItems/ItemProfile/ItemProfileCreate";
import ItemProfile from "./pages/admin/ZoneItems/ItemProfile/ItemProfile";
import { useEffect } from "react";
import { initFlowbite } from "flowbite";
import UjUgyfelAdatokCreate from "./pages/calculator/Form/KalkulacioTuratervezes/UjUgyfelAdatok/UjUgyfelAdatokCreate";
function App() {
  return (
    <>
      <Routes>
        <Route element={<IsAuth />}>
          <Route path={ROUTES.AUTH} element={<Auth />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={`admin`} />}>
          {/* Start Admin Routes */}
          <Route path={ROUTES.ADMIN_HOME} element={<AdminMainPage />} />
          <Route path={ROUTES.ADMIN_USERS} element={<Felhasznalo />} />
          <Route path={ROUTES.ADMIN_USER_MANAGE} element={<FelhasznaloModsitasa />} />
          <Route path={ROUTES.ADMIN_ZONE_LIST} element={<Zonak />} />
          <Route path={ROUTES.ADMIN_ZONE_ADD} element={<ZonakAdd />} />
          <Route path={ROUTES.ADMIN_ZONE_EDIT} element={<ZonakEdit />} />
          <Route path={ROUTES.ADMIN_ZONE_ITEMS} element={<WohnZimmer />} />
          <Route path={ROUTES.ADMIN_ZONE_ITEMS_UPDATE} element={<ItemProfile />} />
          <Route path={ROUTES.ADMIN_ZONE_ITEMS_CREATE} element={<ItemProfileCreate />} />
          <Route path={ROUTES.ADMIN_AWARDS} element={<Dijak />} />
          <Route path={ROUTES.ADMIN_CLIENTS} element={<Ugyfelek />} />
          {/* End Admin Routes  */}
        </Route>
        <Route element={<RequireAuth allowedRoles={`cal_user`} />}>
          {/* Calculator Components */}
          <Route path={ROUTES.CAL_LIST} element={<KalkulacioList />} />
          <Route path={ROUTES.CAL_DATA_SHEET} element={<KalkulacioAdatlapja />} />
          <Route path={ROUTES.CAL_MANAGE_CUSTOMER_DATA_CREATE} element={<UjUgyfelAdatokCreate />} />
          <Route path={ROUTES.CAL_MANAGE_CUSTOMER_DATA} element={<UjUgyfelAdatok />} />
          <Route path={ROUTES.CAL_MANAGE_TOUR_PLAN} element={<Turatervezes />} />
          <Route path={ROUTES.CAL_MANAGE_ADDRESS_DATA} element={<KalkulacioAdatok />} />
          <Route path={ROUTES.CAL_MANAGE_ITEM_LIST} element={<KalkulacioTetellista />} />
          <Route path={ROUTES.CAL_MANAGE_LOGISTIC_DATA} element={<KalkulacioLogisztikai />} />
          <Route path={ROUTES.CAL_MANAGE_SUMMARY} element={<KalkulacioOsszegzes />} />
          {/* End Calculator Routes */}
        </Route>
      </Routes>
    </>
  );
}
export default App;
